<template>
  <div>
      <h1>(404) Nie znaleziono strony</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>